// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
import {
  AddressFragmentDoc,
  CategoryFragmentDoc,
  ChecklistFragmentDoc,
  OrderAttributeFragmentDoc,
  OrderServiceFragmentDoc,
  ReservationListFragmentDoc,
  ReservationVmFragmentDoc,
  V2BundleListFragmentDoc,
} from "./fragments.generated";

const defaultOptions = {} as const;
export type HomepageBannerFragment = {
  buttonText: string;
  description: string;
  desktopImgUrl: string;
  isButtonVisible: boolean;
  isDescriptionVisible: boolean;
  isTitleVisible: boolean;
  isUrlVisible: boolean;
  mobileImgUrl: string;
  title: string;
  url: string;
  localization: { id: string; name: string };
  carousel: Array<{ id: string; desktopUrl: string; mobileUrl: string }>;
};

export type IssueActionFragment = { description?: string | null; id: string; title: string };

export type IssueFragment = {
  code: APITypes.IssueDefinitionCode;
  description?: string | null;
  id: string;
  orderId: string;
  title: string;
  workerId: string;
  actions?: Array<{ description?: string | null; id: string; title: string }> | null;
};

export type StoredDiscountFragment = {
  code: string;
  description?: string | null;
  expiresAt?: string | null;
  id: string;
  value: number;
};

export type DiscountReceiptFragment = {
  discountCode: string;
  discountType: APITypes.StoredDiscountType;
  discountValue: number;
};

export type JobOfferFragment = {
  id: string;
  reward?: number | null;
  rewardCurrency?: string | null;
  subscriptionCreatedAt?: string | null;
  status: APITypes.JobStatus;
  isHotJobOffer?: number | null;
  customer: { avatar?: string | null; name: string };
  order: {
    startDate: string;
    timeConsumption: string;
    address: {
      city: string;
      doorCode?: string | null;
      floorArea?: number | null;
      notes?: string | null;
      postalOrZipCode: string;
      streetAddress1: string;
      streetAddress2?: string | null;
      type?: APITypes.ApartmentType | null;
    };
    attributes: Array<{
      currency: string;
      price: number;
      quantity?: number | null;
      timeConsumption?: string | null;
      attribute: {
        description?: string | null;
        id: string;
        isRequired?: boolean | null;
        name: string;
        position: number;
        type: APITypes.AttributeType;
        options: Array<{
          description?: string | null;
          id: string;
          isFeatured: boolean;
          name: string;
          position: number;
          price: number;
          timeConsumption: string;
        }>;
      };
      values: Array<{
        description?: string | null;
        id: string;
        isFeatured: boolean;
        name: string;
        position: number;
        price: number;
        timeConsumption: string;
      } | null>;
    }>;
    bundle: {
      name: string;
      categoryType?: APITypes.CategoryType | null;
      checkList: Array<{
        description?: string | null;
        iconUrl?: string | null;
        position?: number | null;
        title?: string | null;
      }>;
    };
    periodicity: { title: string };
    services: Array<{
      currency: string;
      price: number;
      timeConsumption: string;
      service: {
        additionalDescription: string;
        description: string;
        icon: string;
        id: string;
        name: string;
        variants: Array<{
          description: string;
          id: string;
          price: number;
          isFeatured: boolean;
          isFree: boolean;
          timeConsumption: string;
          title: string;
        }>;
      };
      variants: Array<{
        currency: string;
        description: string;
        isFree?: boolean | null;
        price: number;
        quantity: number;
        sumPrice: any;
        sumTimeConsumption: string;
        timeConsumption: string;
        title: string;
        variantId: string;
      }>;
    }>;
  };
};

export type GetJobOffersQueryVariables = APITypes.Exact<{
  locationId: APITypes.Scalars["String"]["input"];
  bundleId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
}>;

export type GetJobOffersQuery = {
  listJobOffers: Array<{
    id: string;
    reward?: number | null;
    rewardCurrency?: string | null;
    subscriptionCreatedAt?: string | null;
    status: APITypes.JobStatus;
    isHotJobOffer?: number | null;
    customer: { avatar?: string | null; name: string };
    order: {
      startDate: string;
      timeConsumption: string;
      address: {
        city: string;
        doorCode?: string | null;
        floorArea?: number | null;
        notes?: string | null;
        postalOrZipCode: string;
        streetAddress1: string;
        streetAddress2?: string | null;
        type?: APITypes.ApartmentType | null;
      };
      attributes: Array<{
        currency: string;
        price: number;
        quantity?: number | null;
        timeConsumption?: string | null;
        attribute: {
          description?: string | null;
          id: string;
          isRequired?: boolean | null;
          name: string;
          position: number;
          type: APITypes.AttributeType;
          options: Array<{
            description?: string | null;
            id: string;
            isFeatured: boolean;
            name: string;
            position: number;
            price: number;
            timeConsumption: string;
          }>;
        };
        values: Array<{
          description?: string | null;
          id: string;
          isFeatured: boolean;
          name: string;
          position: number;
          price: number;
          timeConsumption: string;
        } | null>;
      }>;
      bundle: {
        name: string;
        categoryType?: APITypes.CategoryType | null;
        checkList: Array<{
          description?: string | null;
          iconUrl?: string | null;
          position?: number | null;
          title?: string | null;
        }>;
      };
      periodicity: { title: string };
      services: Array<{
        currency: string;
        price: number;
        timeConsumption: string;
        service: {
          additionalDescription: string;
          description: string;
          icon: string;
          id: string;
          name: string;
          variants: Array<{
            description: string;
            id: string;
            price: number;
            isFeatured: boolean;
            isFree: boolean;
            timeConsumption: string;
            title: string;
          }>;
        };
        variants: Array<{
          currency: string;
          description: string;
          isFree?: boolean | null;
          price: number;
          quantity: number;
          sumPrice: any;
          sumTimeConsumption: string;
          timeConsumption: string;
          title: string;
          variantId: string;
        }>;
      }>;
    };
  }>;
};

export type GetJobOfferByIdQueryVariables = APITypes.Exact<{
  jobId: APITypes.Scalars["String"]["input"];
  bundleId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
}>;

export type GetJobOfferByIdQuery = {
  getJobOfferById: {
    id: string;
    reward?: number | null;
    rewardCurrency?: string | null;
    subscriptionCreatedAt?: string | null;
    status: APITypes.JobStatus;
    isHotJobOffer?: number | null;
    customer: { avatar?: string | null; name: string };
    order: {
      startDate: string;
      timeConsumption: string;
      address: {
        city: string;
        doorCode?: string | null;
        floorArea?: number | null;
        notes?: string | null;
        postalOrZipCode: string;
        streetAddress1: string;
        streetAddress2?: string | null;
        type?: APITypes.ApartmentType | null;
      };
      attributes: Array<{
        currency: string;
        price: number;
        quantity?: number | null;
        timeConsumption?: string | null;
        attribute: {
          description?: string | null;
          id: string;
          isRequired?: boolean | null;
          name: string;
          position: number;
          type: APITypes.AttributeType;
          options: Array<{
            description?: string | null;
            id: string;
            isFeatured: boolean;
            name: string;
            position: number;
            price: number;
            timeConsumption: string;
          }>;
        };
        values: Array<{
          description?: string | null;
          id: string;
          isFeatured: boolean;
          name: string;
          position: number;
          price: number;
          timeConsumption: string;
        } | null>;
      }>;
      bundle: {
        name: string;
        categoryType?: APITypes.CategoryType | null;
        checkList: Array<{
          description?: string | null;
          iconUrl?: string | null;
          position?: number | null;
          title?: string | null;
        }>;
      };
      periodicity: { title: string };
      services: Array<{
        currency: string;
        price: number;
        timeConsumption: string;
        service: {
          additionalDescription: string;
          description: string;
          icon: string;
          id: string;
          name: string;
          variants: Array<{
            description: string;
            id: string;
            price: number;
            isFeatured: boolean;
            isFree: boolean;
            timeConsumption: string;
            title: string;
          }>;
        };
        variants: Array<{
          currency: string;
          description: string;
          isFree?: boolean | null;
          price: number;
          quantity: number;
          sumPrice: any;
          sumTimeConsumption: string;
          timeConsumption: string;
          title: string;
          variantId: string;
        }>;
      }>;
    };
  };
};

export type GetReservationsQueryVariables = APITypes.Exact<{
  filter?: APITypes.InputMaybe<APITypes.ReservationFilter>;
  isCustomerApp: APITypes.Scalars["Boolean"]["input"];
}>;

export type GetReservationsQuery = {
  listReservations: Array<{
    adminNote: string;
    currency: string;
    customerNote: string;
    endDate: string;
    id: string;
    laborPrice?: number;
    price?: number;
    startDate: string;
    status: APITypes.ReservationStatus;
    timeConsumption: string;
    address: {
      city: string;
      doorCode?: string | null;
      floorArea?: number | null;
      notes?: string | null;
      postalOrZipCode: string;
      streetAddress1: string;
      streetAddress2?: string | null;
      type?: APITypes.ApartmentType | null;
    };
    bundle: { name: string; checkList: Array<{ title?: string | null }> };
    customer?: { avatar?: string | null; name: string; phone: string };
    payment?: {
      amount: number;
      appliedDiscount: number;
      currency: string;
      id: string;
      paymentMethodId?: string | null;
      paymentUpdateDate?: string | null;
      status: APITypes.PaymentStatus;
      stripePaymentNextStep?:
        | {
            clientSecret: string;
            paymentIntentId: string;
            redirectUrl: string;
            type: APITypes.PaymentActionType;
          }
        | {
            clientSecret: string;
            paymentIntentId: string;
            stripeSdkData: string;
            type: APITypes.PaymentActionType;
          }
        | null;
    } | null;
    periodicity: { title: string };
    review?: { id: string } | null;
    services: Array<{
      service: { id: string; name: string };
      variants: Array<{ quantity: number; variantId: string }>;
    } | null>;
    subscription?: { id: string; startDate: string; periodicity: { cycleDuration: string } } | null;
    workers: Array<{
      avatar?: string | null;
      description?: string | null;
      experience?: string | null;
      id: string;
      name: string;
      phone: string;
    } | null>;
  }>;
};

export type GetMonthlyReservationsQueryVariables = APITypes.Exact<{
  filter?: APITypes.InputMaybe<APITypes.ReservationFilter>;
}>;

export type GetMonthlyReservationsQuery = {
  listReservations: Array<{
    id: string;
    startDate: string;
    timeConsumption: string;
    status: APITypes.ReservationStatus;
    laborPrice: number;
  }>;
};

export type GetReservationByIdQueryVariables = APITypes.Exact<{
  orderId: APITypes.Scalars["String"]["input"];
  isCustomerApp: APITypes.Scalars["Boolean"]["input"];
  bundleId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
}>;

export type GetReservationByIdQuery = {
  getReservationById: {
    adminNote: string;
    currency: string;
    customerNote: string;
    id: string;
    laborPrice?: number;
    locationId: string;
    price?: number;
    shouldUseDiscount?: boolean;
    startDate: string;
    status: APITypes.ReservationStatus;
    timeConsumption: string;
    address: {
      city: string;
      doorCode?: string | null;
      floorArea?: number | null;
      notes?: string | null;
      postalOrZipCode: string;
      streetAddress1: string;
      streetAddress2?: string | null;
      type?: APITypes.ApartmentType | null;
    };
    attributes: Array<{
      currency: string;
      price: number;
      quantity?: number | null;
      timeConsumption?: string | null;
      attribute: {
        description?: string | null;
        id: string;
        isRequired?: boolean | null;
        name: string;
        position: number;
        type: APITypes.AttributeType;
        options: Array<{
          description?: string | null;
          id: string;
          isFeatured: boolean;
          name: string;
          position: number;
          price: number;
          timeConsumption: string;
        }>;
      };
      values: Array<{
        description?: string | null;
        id: string;
        isFeatured: boolean;
        name: string;
        position: number;
        price: number;
        timeConsumption: string;
      } | null>;
    } | null>;
    bundle: { id: string; categoryType?: APITypes.CategoryType | null; name: string; slug: string };
    completionPhotos?: Array<{ file: { url: string } }> | null;
    customer?: { avatar?: string | null; name: string; phone: string };
    discounts?: Array<{ fixedValue: number; id: string; type: APITypes.OrderDiscountType }> | null;
    payment?: {
      amount: number;
      appliedDiscount: number;
      currency: string;
      id: string;
      paymentMethodId?: string | null;
      paymentUpdateDate?: string | null;
      status: APITypes.PaymentStatus;
      stripePaymentNextStep?:
        | {
            clientSecret: string;
            paymentIntentId: string;
            redirectUrl: string;
            type: APITypes.PaymentActionType;
          }
        | {
            clientSecret: string;
            paymentIntentId: string;
            stripeSdkData: string;
            type: APITypes.PaymentActionType;
          }
        | null;
    } | null;
    periodicity: { title: string };
    review?: { id: string } | null;
    services: Array<{
      currency: string;
      price: number;
      timeConsumption: string;
      service: {
        additionalDescription: string;
        description: string;
        icon: string;
        id: string;
        name: string;
        variants: Array<{
          description: string;
          id: string;
          price: number;
          isFeatured: boolean;
          isFree: boolean;
          timeConsumption: string;
          title: string;
        }>;
      };
      variants: Array<{
        currency: string;
        description: string;
        isFree?: boolean | null;
        price: number;
        quantity: number;
        sumPrice: any;
        sumTimeConsumption: string;
        timeConsumption: string;
        title: string;
        variantId: string;
      }>;
    } | null>;
    subscription?: { id: string; startDate: string; periodicity: { cycleDuration: string } } | null;
    workers: Array<{
      avatar?: string | null;
      description?: string | null;
      experience?: string | null;
      id: string;
      name: string;
      phone: string;
    } | null>;
  };
};

export type ListCategoriesQueryVariables = APITypes.Exact<{
  localizationId: APITypes.Scalars["String"]["input"];
}>;

export type ListCategoriesQuery = {
  listCategories: Array<{
    bannerRedirection: string;
    description?: string | null;
    desktopUrl: string;
    extraDesktopUrl: string;
    extraMobileUrl: string;
    desktopBannerUrl: string;
    id: string;
    isBanner: boolean;
    isFeatured: boolean;
    localizationId: string;
    mobileUrl: string;
    mobileBannerUrl: string;
    name: string;
    position: number;
    slug: string;
    startingPrice: number;
  }>;
};

export type V2GetCategoryByIdQueryVariables = APITypes.Exact<{
  id: APITypes.Scalars["String"]["input"];
}>;

export type V2GetCategoryByIdQuery = {
  v2GetCategoryById: {
    bannerRedirection: string;
    description?: string | null;
    desktopUrl: string;
    extraDesktopUrl: string;
    extraMobileUrl: string;
    desktopBannerUrl: string;
    id: string;
    isBanner: boolean;
    isFeatured: boolean;
    localizationId: string;
    mobileUrl: string;
    mobileBannerUrl: string;
    name: string;
    position: number;
    slug: string;
    startingPrice: number;
  };
};

export type ListCategoryCarouselQueryVariables = APITypes.Exact<{
  categoryId: APITypes.Scalars["String"]["input"];
}>;

export type ListCategoryCarouselQuery = {
  listCategoryCarousel: Array<{ id: string; desktopUrl: string; mobileUrl: string }>;
};

export type V2ListBundlesQueryVariables = APITypes.Exact<{
  localizationId: APITypes.Scalars["String"]["input"];
  categoryId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
}>;

export type V2ListBundlesQuery = {
  v2ListBundles: Array<{
    bannerRedirection: string;
    categoryType: APITypes.CategoryType;
    currency: string;
    description: string;
    desktopBanner: string;
    id: string;
    isBanner: boolean;
    isFeatured: boolean;
    name: string;
    mobileBanner: string;
    position: number;
    slug: string;
    startingPrice: number;
    checkList: Array<{ description: string; iconUrl: string; position: number; title: string }>;
  }>;
};

export type GetHomepageBannerByLocalizationIdQueryVariables = APITypes.Exact<{
  data: APITypes.GetHomepageBannerByLocalizationIdInput;
}>;

export type GetHomepageBannerByLocalizationIdQuery = {
  getHomepageBannerByLocalizationId: {
    buttonText: string;
    description: string;
    desktopImgUrl: string;
    isButtonVisible: boolean;
    isDescriptionVisible: boolean;
    isTitleVisible: boolean;
    isUrlVisible: boolean;
    mobileImgUrl: string;
    title: string;
    url: string;
    localization: { id: string; name: string };
    carousel: Array<{ id: string; desktopUrl: string; mobileUrl: string }>;
  };
};

export type GetHomepageBannersQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type GetHomepageBannersQuery = {
  listHomepageBanners: Array<{
    buttonText: string;
    description: string;
    desktopImgUrl: string;
    isButtonVisible: boolean;
    isDescriptionVisible: boolean;
    isTitleVisible: boolean;
    isUrlVisible: boolean;
    mobileImgUrl: string;
    title: string;
    url: string;
    localization: { id: string; name: string };
    carousel: Array<{ id: string; desktopUrl: string; mobileUrl: string }>;
  }>;
};

export type GetIssueQueryVariables = APITypes.Exact<{
  issueId: APITypes.Scalars["String"]["input"];
}>;

export type GetIssueQuery = {
  getIssue: {
    code: APITypes.IssueDefinitionCode;
    description?: string | null;
    id: string;
    orderId: string;
    title: string;
    workerId: string;
    actions?: Array<{ description?: string | null; id: string; title: string }> | null;
  };
};

export type GetUnresolvedIssuesQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type GetUnresolvedIssuesQuery = {
  getUnresolvedIssues: Array<{
    code: APITypes.IssueDefinitionCode;
    description?: string | null;
    id: string;
    orderId: string;
    title: string;
    workerId: string;
    actions?: Array<{ description?: string | null; id: string; title: string }> | null;
  }>;
};

export type ListPaymentMethodsQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListPaymentMethodsQuery = {
  listPaymentMethods: Array<{ id: string; brand: string; last4: string }>;
};

export type GetVirtualWalletBalanceQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type GetVirtualWalletBalanceQuery = {
  getVirtualWalletBalance: { balance: number; currency: string };
};

export type ListOwnedCouponsQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListOwnedCouponsQuery = {
  listOwnedCoupons: Array<{
    code: string;
    description?: string | null;
    expiresAt?: string | null;
    id: string;
    value: number;
  }>;
};

export type AcceptReservationMutationVariables = APITypes.Exact<{
  jobId: APITypes.Scalars["String"]["input"];
  bundleId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
}>;

export type AcceptReservationMutation = {
  applyForJob: {
    id: string;
    reward?: number | null;
    rewardCurrency?: string | null;
    subscriptionCreatedAt?: string | null;
    status: APITypes.JobStatus;
    isHotJobOffer?: number | null;
    customer: { avatar?: string | null; name: string };
    order: {
      startDate: string;
      timeConsumption: string;
      address: {
        city: string;
        doorCode?: string | null;
        floorArea?: number | null;
        notes?: string | null;
        postalOrZipCode: string;
        streetAddress1: string;
        streetAddress2?: string | null;
        type?: APITypes.ApartmentType | null;
      };
      attributes: Array<{
        currency: string;
        price: number;
        quantity?: number | null;
        timeConsumption?: string | null;
        attribute: {
          description?: string | null;
          id: string;
          isRequired?: boolean | null;
          name: string;
          position: number;
          type: APITypes.AttributeType;
          options: Array<{
            description?: string | null;
            id: string;
            isFeatured: boolean;
            name: string;
            position: number;
            price: number;
            timeConsumption: string;
          }>;
        };
        values: Array<{
          description?: string | null;
          id: string;
          isFeatured: boolean;
          name: string;
          position: number;
          price: number;
          timeConsumption: string;
        } | null>;
      }>;
      bundle: {
        name: string;
        categoryType?: APITypes.CategoryType | null;
        checkList: Array<{
          description?: string | null;
          iconUrl?: string | null;
          position?: number | null;
          title?: string | null;
        }>;
      };
      periodicity: { title: string };
      services: Array<{
        currency: string;
        price: number;
        timeConsumption: string;
        service: {
          additionalDescription: string;
          description: string;
          icon: string;
          id: string;
          name: string;
          variants: Array<{
            description: string;
            id: string;
            price: number;
            isFeatured: boolean;
            isFree: boolean;
            timeConsumption: string;
            title: string;
          }>;
        };
        variants: Array<{
          currency: string;
          description: string;
          isFree?: boolean | null;
          price: number;
          quantity: number;
          sumPrice: any;
          sumTimeConsumption: string;
          timeConsumption: string;
          title: string;
          variantId: string;
        }>;
      }>;
    };
  };
};

export type UpdateStatusOrderMutationVariables = APITypes.Exact<{
  orderId: APITypes.Scalars["String"]["input"];
}>;

export type UpdateStatusOrderMutation = { startOrder: { id: string } };

export type CompleteOrderMutationVariables = APITypes.Exact<{
  orderId: APITypes.Scalars["String"]["input"];
  file: APITypes.Scalars["String"]["input"];
}>;

export type CompleteOrderMutation = { submitOrderCompletion: { id: string } };

export type AcceptWorkMutationVariables = APITypes.Exact<{
  orderId: APITypes.Scalars["String"]["input"];
}>;

export type AcceptWorkMutation = { acceptWorkSubmission: { id: string } };

export type ResolveIssueMutationVariables = APITypes.Exact<{
  actionId: APITypes.Scalars["String"]["input"];
  issueId: APITypes.Scalars["String"]["input"];
}>;

export type ResolveIssueMutation = {
  resolveIssue: {
    code: APITypes.IssueDefinitionCode;
    description?: string | null;
    id: string;
    orderId: string;
    title: string;
    workerId: string;
    actions?: Array<{ description?: string | null; id: string; title: string }> | null;
  };
};

export type StoreDiscountMutationVariables = APITypes.Exact<{
  code: APITypes.Scalars["String"]["input"];
}>;

export type StoreDiscountMutation = {
  storeDiscount: {
    discountCode: string;
    discountType: APITypes.StoredDiscountType;
    discountValue: number;
  };
};

export const HomepageBannerFragmentDoc = gql`
    fragment HomepageBanner on HomepageBanner {
  buttonText
  description
  desktopImgUrl
  isButtonVisible
  isDescriptionVisible
  isTitleVisible
  isUrlVisible
  mobileImgUrl
  title
  url
  localization {
    id
    name
  }
  carousel {
    id
    desktopUrl
    mobileUrl
  }
}
    `;
export const IssueActionFragmentDoc = gql`
    fragment IssueAction on IssueAction {
  description
  id
  title
}
    `;
export const IssueFragmentDoc = gql`
    fragment Issue on Issue {
  actions {
    ...IssueAction
  }
  code
  description
  id
  orderId
  title
  workerId
}
    ${IssueActionFragmentDoc}`;
export const StoredDiscountFragmentDoc = gql`
    fragment StoredDiscount on StoredDiscount {
  code
  description
  expiresAt
  id
  value
}
    `;
export const DiscountReceiptFragmentDoc = gql`
    fragment DiscountReceipt on DiscountReceipt {
  discountCode
  discountType
  discountValue
}
    `;
export const JobOfferFragmentDoc = gql`
    fragment JobOffer on JobOffer {
  customer {
    avatar
    name
  }
  id
  order {
    address {
      ...Address
    }
    attributes {
      ...OrderAttribute
    }
    bundle {
      name
      categoryType
      checkList {
        ...Checklist
      }
    }
    periodicity {
      title
    }
    services {
      ...OrderService
    }
    startDate
    timeConsumption
  }
  reward
  rewardCurrency
  subscriptionCreatedAt
  status
  isHotJobOffer
}
    ${AddressFragmentDoc}
${OrderAttributeFragmentDoc}
${ChecklistFragmentDoc}
${OrderServiceFragmentDoc}`;
export const GetJobOffersDocument = gql`
    query GetJobOffers($locationId: String!, $bundleId: String) {
  listJobOffers(locationId: $locationId) {
    ...JobOffer
  }
}
    ${JobOfferFragmentDoc}`;

/**
 * __useGetJobOffersQuery__
 *
 * To run a query within a React component, call `useGetJobOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobOffersQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetJobOffersQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobOffersQuery, GetJobOffersQueryVariables> &
    ({ variables: GetJobOffersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobOffersQuery, GetJobOffersQueryVariables>(
    GetJobOffersDocument,
    options,
  );
}
export function useGetJobOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobOffersQuery, GetJobOffersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobOffersQuery, GetJobOffersQueryVariables>(
    GetJobOffersDocument,
    options,
  );
}
export function useGetJobOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobOffersQuery, GetJobOffersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobOffersQuery, GetJobOffersQueryVariables>(
    GetJobOffersDocument,
    options,
  );
}
export type GetJobOffersQueryHookResult = ReturnType<typeof useGetJobOffersQuery>;
export type GetJobOffersLazyQueryHookResult = ReturnType<typeof useGetJobOffersLazyQuery>;
export type GetJobOffersSuspenseQueryHookResult = ReturnType<typeof useGetJobOffersSuspenseQuery>;
export type GetJobOffersQueryResult = Apollo.QueryResult<
  GetJobOffersQuery,
  GetJobOffersQueryVariables
>;
export const GetJobOfferByIdDocument = gql`
    query GetJobOfferById($jobId: String!, $bundleId: String) {
  getJobOfferById(jobId: $jobId) {
    ...JobOffer
  }
}
    ${JobOfferFragmentDoc}`;

/**
 * __useGetJobOfferByIdQuery__
 *
 * To run a query within a React component, call `useGetJobOfferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobOfferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobOfferByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetJobOfferByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables> &
    ({ variables: GetJobOfferByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables>(
    GetJobOfferByIdDocument,
    options,
  );
}
export function useGetJobOfferByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables>(
    GetJobOfferByIdDocument,
    options,
  );
}
export function useGetJobOfferByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobOfferByIdQuery, GetJobOfferByIdQueryVariables>(
    GetJobOfferByIdDocument,
    options,
  );
}
export type GetJobOfferByIdQueryHookResult = ReturnType<typeof useGetJobOfferByIdQuery>;
export type GetJobOfferByIdLazyQueryHookResult = ReturnType<typeof useGetJobOfferByIdLazyQuery>;
export type GetJobOfferByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetJobOfferByIdSuspenseQuery
>;
export type GetJobOfferByIdQueryResult = Apollo.QueryResult<
  GetJobOfferByIdQuery,
  GetJobOfferByIdQueryVariables
>;
export const GetReservationsDocument = gql`
    query GetReservations($filter: ReservationFilter, $isCustomerApp: Boolean!) {
  listReservations(filter: $filter) {
    ...ReservationList
  }
}
    ${ReservationListFragmentDoc}`;

/**
 * __useGetReservationsQuery__
 *
 * To run a query within a React component, call `useGetReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      isCustomerApp: // value for 'isCustomerApp'
 *   },
 * });
 */
export function useGetReservationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables> &
    ({ variables: GetReservationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReservationsQuery, GetReservationsQueryVariables>(
    GetReservationsDocument,
    options,
  );
}
export function useGetReservationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReservationsQuery, GetReservationsQueryVariables>(
    GetReservationsDocument,
    options,
  );
}
export function useGetReservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReservationsQuery, GetReservationsQueryVariables>(
    GetReservationsDocument,
    options,
  );
}
export type GetReservationsQueryHookResult = ReturnType<typeof useGetReservationsQuery>;
export type GetReservationsLazyQueryHookResult = ReturnType<typeof useGetReservationsLazyQuery>;
export type GetReservationsSuspenseQueryHookResult = ReturnType<
  typeof useGetReservationsSuspenseQuery
>;
export type GetReservationsQueryResult = Apollo.QueryResult<
  GetReservationsQuery,
  GetReservationsQueryVariables
>;
export const GetMonthlyReservationsDocument = gql`
    query GetMonthlyReservations($filter: ReservationFilter) {
  listReservations(filter: $filter) {
    id
    startDate
    timeConsumption
    status
    laborPrice
  }
}
    `;

/**
 * __useGetMonthlyReservationsQuery__
 *
 * To run a query within a React component, call `useGetMonthlyReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMonthlyReservationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMonthlyReservationsQuery,
    GetMonthlyReservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMonthlyReservationsQuery, GetMonthlyReservationsQueryVariables>(
    GetMonthlyReservationsDocument,
    options,
  );
}
export function useGetMonthlyReservationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMonthlyReservationsQuery,
    GetMonthlyReservationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMonthlyReservationsQuery, GetMonthlyReservationsQueryVariables>(
    GetMonthlyReservationsDocument,
    options,
  );
}
export function useGetMonthlyReservationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMonthlyReservationsQuery,
        GetMonthlyReservationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMonthlyReservationsQuery, GetMonthlyReservationsQueryVariables>(
    GetMonthlyReservationsDocument,
    options,
  );
}
export type GetMonthlyReservationsQueryHookResult = ReturnType<
  typeof useGetMonthlyReservationsQuery
>;
export type GetMonthlyReservationsLazyQueryHookResult = ReturnType<
  typeof useGetMonthlyReservationsLazyQuery
>;
export type GetMonthlyReservationsSuspenseQueryHookResult = ReturnType<
  typeof useGetMonthlyReservationsSuspenseQuery
>;
export type GetMonthlyReservationsQueryResult = Apollo.QueryResult<
  GetMonthlyReservationsQuery,
  GetMonthlyReservationsQueryVariables
>;
export const GetReservationByIdDocument = gql`
    query GetReservationById($orderId: String!, $isCustomerApp: Boolean!, $bundleId: String) {
  getReservationById(orderId: $orderId) {
    ...ReservationVM
  }
}
    ${ReservationVmFragmentDoc}`;

/**
 * __useGetReservationByIdQuery__
 *
 * To run a query within a React component, call `useGetReservationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      isCustomerApp: // value for 'isCustomerApp'
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetReservationByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetReservationByIdQuery, GetReservationByIdQueryVariables> &
    ({ variables: GetReservationByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(
    GetReservationByIdDocument,
    options,
  );
}
export function useGetReservationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReservationByIdQuery,
    GetReservationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(
    GetReservationByIdDocument,
    options,
  );
}
export function useGetReservationByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReservationByIdQuery, GetReservationByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(
    GetReservationByIdDocument,
    options,
  );
}
export type GetReservationByIdQueryHookResult = ReturnType<typeof useGetReservationByIdQuery>;
export type GetReservationByIdLazyQueryHookResult = ReturnType<
  typeof useGetReservationByIdLazyQuery
>;
export type GetReservationByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetReservationByIdSuspenseQuery
>;
export type GetReservationByIdQueryResult = Apollo.QueryResult<
  GetReservationByIdQuery,
  GetReservationByIdQueryVariables
>;
export const ListCategoriesDocument = gql`
    query ListCategories($localizationId: String!) {
  listCategories(localizationId: $localizationId) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useListCategoriesQuery__
 *
 * To run a query within a React component, call `useListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoriesQuery({
 *   variables: {
 *      localizationId: // value for 'localizationId'
 *   },
 * });
 */
export function useListCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables> &
    ({ variables: ListCategoriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(
    ListCategoriesDocument,
    options,
  );
}
export function useListCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(
    ListCategoriesDocument,
    options,
  );
}
export function useListCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(
    ListCategoriesDocument,
    options,
  );
}
export type ListCategoriesQueryHookResult = ReturnType<typeof useListCategoriesQuery>;
export type ListCategoriesLazyQueryHookResult = ReturnType<typeof useListCategoriesLazyQuery>;
export type ListCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useListCategoriesSuspenseQuery
>;
export type ListCategoriesQueryResult = Apollo.QueryResult<
  ListCategoriesQuery,
  ListCategoriesQueryVariables
>;
export const V2GetCategoryByIdDocument = gql`
    query V2GetCategoryById($id: String!) {
  v2GetCategoryById(id: $id) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useV2GetCategoryByIdQuery__
 *
 * To run a query within a React component, call `useV2GetCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2GetCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2GetCategoryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useV2GetCategoryByIdQuery(
  baseOptions: Apollo.QueryHookOptions<V2GetCategoryByIdQuery, V2GetCategoryByIdQueryVariables> &
    ({ variables: V2GetCategoryByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<V2GetCategoryByIdQuery, V2GetCategoryByIdQueryVariables>(
    V2GetCategoryByIdDocument,
    options,
  );
}
export function useV2GetCategoryByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    V2GetCategoryByIdQuery,
    V2GetCategoryByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<V2GetCategoryByIdQuery, V2GetCategoryByIdQueryVariables>(
    V2GetCategoryByIdDocument,
    options,
  );
}
export function useV2GetCategoryByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<V2GetCategoryByIdQuery, V2GetCategoryByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<V2GetCategoryByIdQuery, V2GetCategoryByIdQueryVariables>(
    V2GetCategoryByIdDocument,
    options,
  );
}
export type V2GetCategoryByIdQueryHookResult = ReturnType<typeof useV2GetCategoryByIdQuery>;
export type V2GetCategoryByIdLazyQueryHookResult = ReturnType<typeof useV2GetCategoryByIdLazyQuery>;
export type V2GetCategoryByIdSuspenseQueryHookResult = ReturnType<
  typeof useV2GetCategoryByIdSuspenseQuery
>;
export type V2GetCategoryByIdQueryResult = Apollo.QueryResult<
  V2GetCategoryByIdQuery,
  V2GetCategoryByIdQueryVariables
>;
export const ListCategoryCarouselDocument = gql`
    query ListCategoryCarousel($categoryId: String!) {
  listCategoryCarousel(categoryId: $categoryId) {
    id
    desktopUrl
    mobileUrl
  }
}
    `;

/**
 * __useListCategoryCarouselQuery__
 *
 * To run a query within a React component, call `useListCategoryCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoryCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoryCarouselQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useListCategoryCarouselQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCategoryCarouselQuery,
    ListCategoryCarouselQueryVariables
  > &
    ({ variables: ListCategoryCarouselQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCategoryCarouselQuery, ListCategoryCarouselQueryVariables>(
    ListCategoryCarouselDocument,
    options,
  );
}
export function useListCategoryCarouselLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCategoryCarouselQuery,
    ListCategoryCarouselQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCategoryCarouselQuery, ListCategoryCarouselQueryVariables>(
    ListCategoryCarouselDocument,
    options,
  );
}
export function useListCategoryCarouselSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCategoryCarouselQuery,
        ListCategoryCarouselQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCategoryCarouselQuery, ListCategoryCarouselQueryVariables>(
    ListCategoryCarouselDocument,
    options,
  );
}
export type ListCategoryCarouselQueryHookResult = ReturnType<typeof useListCategoryCarouselQuery>;
export type ListCategoryCarouselLazyQueryHookResult = ReturnType<
  typeof useListCategoryCarouselLazyQuery
>;
export type ListCategoryCarouselSuspenseQueryHookResult = ReturnType<
  typeof useListCategoryCarouselSuspenseQuery
>;
export type ListCategoryCarouselQueryResult = Apollo.QueryResult<
  ListCategoryCarouselQuery,
  ListCategoryCarouselQueryVariables
>;
export const V2ListBundlesDocument = gql`
    query V2ListBundles($localizationId: String!, $categoryId: String) {
  v2ListBundles(localizationId: $localizationId, categoryId: $categoryId) {
    ...V2BundleList
  }
}
    ${V2BundleListFragmentDoc}`;

/**
 * __useV2ListBundlesQuery__
 *
 * To run a query within a React component, call `useV2ListBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2ListBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2ListBundlesQuery({
 *   variables: {
 *      localizationId: // value for 'localizationId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useV2ListBundlesQuery(
  baseOptions: Apollo.QueryHookOptions<V2ListBundlesQuery, V2ListBundlesQueryVariables> &
    ({ variables: V2ListBundlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<V2ListBundlesQuery, V2ListBundlesQueryVariables>(
    V2ListBundlesDocument,
    options,
  );
}
export function useV2ListBundlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<V2ListBundlesQuery, V2ListBundlesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<V2ListBundlesQuery, V2ListBundlesQueryVariables>(
    V2ListBundlesDocument,
    options,
  );
}
export function useV2ListBundlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<V2ListBundlesQuery, V2ListBundlesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<V2ListBundlesQuery, V2ListBundlesQueryVariables>(
    V2ListBundlesDocument,
    options,
  );
}
export type V2ListBundlesQueryHookResult = ReturnType<typeof useV2ListBundlesQuery>;
export type V2ListBundlesLazyQueryHookResult = ReturnType<typeof useV2ListBundlesLazyQuery>;
export type V2ListBundlesSuspenseQueryHookResult = ReturnType<typeof useV2ListBundlesSuspenseQuery>;
export type V2ListBundlesQueryResult = Apollo.QueryResult<
  V2ListBundlesQuery,
  V2ListBundlesQueryVariables
>;
export const GetHomepageBannerByLocalizationIdDocument = gql`
    query GetHomepageBannerByLocalizationId($data: GetHomepageBannerByLocalizationIdInput!) {
  getHomepageBannerByLocalizationId(data: $data) {
    ...HomepageBanner
  }
}
    ${HomepageBannerFragmentDoc}`;

/**
 * __useGetHomepageBannerByLocalizationIdQuery__
 *
 * To run a query within a React component, call `useGetHomepageBannerByLocalizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomepageBannerByLocalizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomepageBannerByLocalizationIdQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHomepageBannerByLocalizationIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHomepageBannerByLocalizationIdQuery,
    GetHomepageBannerByLocalizationIdQueryVariables
  > &
    (
      | { variables: GetHomepageBannerByLocalizationIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHomepageBannerByLocalizationIdQuery,
    GetHomepageBannerByLocalizationIdQueryVariables
  >(GetHomepageBannerByLocalizationIdDocument, options);
}
export function useGetHomepageBannerByLocalizationIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHomepageBannerByLocalizationIdQuery,
    GetHomepageBannerByLocalizationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHomepageBannerByLocalizationIdQuery,
    GetHomepageBannerByLocalizationIdQueryVariables
  >(GetHomepageBannerByLocalizationIdDocument, options);
}
export function useGetHomepageBannerByLocalizationIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHomepageBannerByLocalizationIdQuery,
        GetHomepageBannerByLocalizationIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHomepageBannerByLocalizationIdQuery,
    GetHomepageBannerByLocalizationIdQueryVariables
  >(GetHomepageBannerByLocalizationIdDocument, options);
}
export type GetHomepageBannerByLocalizationIdQueryHookResult = ReturnType<
  typeof useGetHomepageBannerByLocalizationIdQuery
>;
export type GetHomepageBannerByLocalizationIdLazyQueryHookResult = ReturnType<
  typeof useGetHomepageBannerByLocalizationIdLazyQuery
>;
export type GetHomepageBannerByLocalizationIdSuspenseQueryHookResult = ReturnType<
  typeof useGetHomepageBannerByLocalizationIdSuspenseQuery
>;
export type GetHomepageBannerByLocalizationIdQueryResult = Apollo.QueryResult<
  GetHomepageBannerByLocalizationIdQuery,
  GetHomepageBannerByLocalizationIdQueryVariables
>;
export const GetHomepageBannersDocument = gql`
    query GetHomepageBanners {
  listHomepageBanners {
    ...HomepageBanner
  }
}
    ${HomepageBannerFragmentDoc}`;

/**
 * __useGetHomepageBannersQuery__
 *
 * To run a query within a React component, call `useGetHomepageBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomepageBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomepageBannersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomepageBannersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetHomepageBannersQuery, GetHomepageBannersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHomepageBannersQuery, GetHomepageBannersQueryVariables>(
    GetHomepageBannersDocument,
    options,
  );
}
export function useGetHomepageBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHomepageBannersQuery,
    GetHomepageBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHomepageBannersQuery, GetHomepageBannersQueryVariables>(
    GetHomepageBannersDocument,
    options,
  );
}
export function useGetHomepageBannersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetHomepageBannersQuery, GetHomepageBannersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetHomepageBannersQuery, GetHomepageBannersQueryVariables>(
    GetHomepageBannersDocument,
    options,
  );
}
export type GetHomepageBannersQueryHookResult = ReturnType<typeof useGetHomepageBannersQuery>;
export type GetHomepageBannersLazyQueryHookResult = ReturnType<
  typeof useGetHomepageBannersLazyQuery
>;
export type GetHomepageBannersSuspenseQueryHookResult = ReturnType<
  typeof useGetHomepageBannersSuspenseQuery
>;
export type GetHomepageBannersQueryResult = Apollo.QueryResult<
  GetHomepageBannersQuery,
  GetHomepageBannersQueryVariables
>;
export const GetIssueDocument = gql`
    query GetIssue($issueId: String!) {
  getIssue(issueId: $issueId) {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;

/**
 * __useGetIssueQuery__
 *
 * To run a query within a React component, call `useGetIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssueQuery({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useGetIssueQuery(
  baseOptions: Apollo.QueryHookOptions<GetIssueQuery, GetIssueQueryVariables> &
    ({ variables: GetIssueQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
}
export function useGetIssueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIssueQuery, GetIssueQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
}
export function useGetIssueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIssueQuery, GetIssueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
}
export type GetIssueQueryHookResult = ReturnType<typeof useGetIssueQuery>;
export type GetIssueLazyQueryHookResult = ReturnType<typeof useGetIssueLazyQuery>;
export type GetIssueSuspenseQueryHookResult = ReturnType<typeof useGetIssueSuspenseQuery>;
export type GetIssueQueryResult = Apollo.QueryResult<GetIssueQuery, GetIssueQueryVariables>;
export const GetUnresolvedIssuesDocument = gql`
    query GetUnresolvedIssues {
  getUnresolvedIssues {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;

/**
 * __useGetUnresolvedIssuesQuery__
 *
 * To run a query within a React component, call `useGetUnresolvedIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnresolvedIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnresolvedIssuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnresolvedIssuesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnresolvedIssuesQuery,
    GetUnresolvedIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnresolvedIssuesQuery, GetUnresolvedIssuesQueryVariables>(
    GetUnresolvedIssuesDocument,
    options,
  );
}
export function useGetUnresolvedIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnresolvedIssuesQuery,
    GetUnresolvedIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnresolvedIssuesQuery, GetUnresolvedIssuesQueryVariables>(
    GetUnresolvedIssuesDocument,
    options,
  );
}
export function useGetUnresolvedIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUnresolvedIssuesQuery, GetUnresolvedIssuesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUnresolvedIssuesQuery, GetUnresolvedIssuesQueryVariables>(
    GetUnresolvedIssuesDocument,
    options,
  );
}
export type GetUnresolvedIssuesQueryHookResult = ReturnType<typeof useGetUnresolvedIssuesQuery>;
export type GetUnresolvedIssuesLazyQueryHookResult = ReturnType<
  typeof useGetUnresolvedIssuesLazyQuery
>;
export type GetUnresolvedIssuesSuspenseQueryHookResult = ReturnType<
  typeof useGetUnresolvedIssuesSuspenseQuery
>;
export type GetUnresolvedIssuesQueryResult = Apollo.QueryResult<
  GetUnresolvedIssuesQuery,
  GetUnresolvedIssuesQueryVariables
>;
export const ListPaymentMethodsDocument = gql`
    query ListPaymentMethods {
  listPaymentMethods {
    id
    brand
    last4
  }
}
    `;

/**
 * __useListPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useListPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPaymentMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>(
    ListPaymentMethodsDocument,
    options,
  );
}
export function useListPaymentMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPaymentMethodsQuery,
    ListPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>(
    ListPaymentMethodsDocument,
    options,
  );
}
export function useListPaymentMethodsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPaymentMethodsQuery, ListPaymentMethodsQueryVariables>(
    ListPaymentMethodsDocument,
    options,
  );
}
export type ListPaymentMethodsQueryHookResult = ReturnType<typeof useListPaymentMethodsQuery>;
export type ListPaymentMethodsLazyQueryHookResult = ReturnType<
  typeof useListPaymentMethodsLazyQuery
>;
export type ListPaymentMethodsSuspenseQueryHookResult = ReturnType<
  typeof useListPaymentMethodsSuspenseQuery
>;
export type ListPaymentMethodsQueryResult = Apollo.QueryResult<
  ListPaymentMethodsQuery,
  ListPaymentMethodsQueryVariables
>;
export const GetVirtualWalletBalanceDocument = gql`
    query GetVirtualWalletBalance {
  getVirtualWalletBalance {
    balance
    currency
  }
}
    `;

/**
 * __useGetVirtualWalletBalanceQuery__
 *
 * To run a query within a React component, call `useGetVirtualWalletBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualWalletBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualWalletBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVirtualWalletBalanceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetVirtualWalletBalanceQuery,
    GetVirtualWalletBalanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVirtualWalletBalanceQuery, GetVirtualWalletBalanceQueryVariables>(
    GetVirtualWalletBalanceDocument,
    options,
  );
}
export function useGetVirtualWalletBalanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVirtualWalletBalanceQuery,
    GetVirtualWalletBalanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVirtualWalletBalanceQuery, GetVirtualWalletBalanceQueryVariables>(
    GetVirtualWalletBalanceDocument,
    options,
  );
}
export function useGetVirtualWalletBalanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVirtualWalletBalanceQuery,
        GetVirtualWalletBalanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVirtualWalletBalanceQuery,
    GetVirtualWalletBalanceQueryVariables
  >(GetVirtualWalletBalanceDocument, options);
}
export type GetVirtualWalletBalanceQueryHookResult = ReturnType<
  typeof useGetVirtualWalletBalanceQuery
>;
export type GetVirtualWalletBalanceLazyQueryHookResult = ReturnType<
  typeof useGetVirtualWalletBalanceLazyQuery
>;
export type GetVirtualWalletBalanceSuspenseQueryHookResult = ReturnType<
  typeof useGetVirtualWalletBalanceSuspenseQuery
>;
export type GetVirtualWalletBalanceQueryResult = Apollo.QueryResult<
  GetVirtualWalletBalanceQuery,
  GetVirtualWalletBalanceQueryVariables
>;
export const ListOwnedCouponsDocument = gql`
    query ListOwnedCoupons {
  listOwnedCoupons {
    ...StoredDiscount
  }
}
    ${StoredDiscountFragmentDoc}`;

/**
 * __useListOwnedCouponsQuery__
 *
 * To run a query within a React component, call `useListOwnedCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOwnedCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOwnedCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOwnedCouponsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>(
    ListOwnedCouponsDocument,
    options,
  );
}
export function useListOwnedCouponsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>(
    ListOwnedCouponsDocument,
    options,
  );
}
export function useListOwnedCouponsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListOwnedCouponsQuery, ListOwnedCouponsQueryVariables>(
    ListOwnedCouponsDocument,
    options,
  );
}
export type ListOwnedCouponsQueryHookResult = ReturnType<typeof useListOwnedCouponsQuery>;
export type ListOwnedCouponsLazyQueryHookResult = ReturnType<typeof useListOwnedCouponsLazyQuery>;
export type ListOwnedCouponsSuspenseQueryHookResult = ReturnType<
  typeof useListOwnedCouponsSuspenseQuery
>;
export type ListOwnedCouponsQueryResult = Apollo.QueryResult<
  ListOwnedCouponsQuery,
  ListOwnedCouponsQueryVariables
>;
export const AcceptReservationDocument = gql`
    mutation AcceptReservation($jobId: String!, $bundleId: String) {
  applyForJob(jobId: $jobId) {
    ...JobOffer
  }
}
    ${JobOfferFragmentDoc}`;
export type AcceptReservationMutationFn = Apollo.MutationFunction<
  AcceptReservationMutation,
  AcceptReservationMutationVariables
>;

/**
 * __useAcceptReservationMutation__
 *
 * To run a mutation, you first call `useAcceptReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReservationMutation, { data, loading, error }] = useAcceptReservationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useAcceptReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptReservationMutation,
    AcceptReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptReservationMutation, AcceptReservationMutationVariables>(
    AcceptReservationDocument,
    options,
  );
}
export type AcceptReservationMutationHookResult = ReturnType<typeof useAcceptReservationMutation>;
export type AcceptReservationMutationResult = Apollo.MutationResult<AcceptReservationMutation>;
export type AcceptReservationMutationOptions = Apollo.BaseMutationOptions<
  AcceptReservationMutation,
  AcceptReservationMutationVariables
>;
export const UpdateStatusOrderDocument = gql`
    mutation UpdateStatusOrder($orderId: String!) {
  startOrder(orderId: $orderId) {
    id
  }
}
    `;
export type UpdateStatusOrderMutationFn = Apollo.MutationFunction<
  UpdateStatusOrderMutation,
  UpdateStatusOrderMutationVariables
>;

/**
 * __useUpdateStatusOrderMutation__
 *
 * To run a mutation, you first call `useUpdateStatusOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusOrderMutation, { data, loading, error }] = useUpdateStatusOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useUpdateStatusOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStatusOrderMutation,
    UpdateStatusOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateStatusOrderMutation, UpdateStatusOrderMutationVariables>(
    UpdateStatusOrderDocument,
    options,
  );
}
export type UpdateStatusOrderMutationHookResult = ReturnType<typeof useUpdateStatusOrderMutation>;
export type UpdateStatusOrderMutationResult = Apollo.MutationResult<UpdateStatusOrderMutation>;
export type UpdateStatusOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateStatusOrderMutation,
  UpdateStatusOrderMutationVariables
>;
export const CompleteOrderDocument = gql`
    mutation CompleteOrder($orderId: String!, $file: String!) {
  submitOrderCompletion(orderId: $orderId, file: $file) {
    id
  }
}
    `;
export type CompleteOrderMutationFn = Apollo.MutationFunction<
  CompleteOrderMutation,
  CompleteOrderMutationVariables
>;

/**
 * __useCompleteOrderMutation__
 *
 * To run a mutation, you first call `useCompleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOrderMutation, { data, loading, error }] = useCompleteOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCompleteOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteOrderMutation, CompleteOrderMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteOrderMutation, CompleteOrderMutationVariables>(
    CompleteOrderDocument,
    options,
  );
}
export type CompleteOrderMutationHookResult = ReturnType<typeof useCompleteOrderMutation>;
export type CompleteOrderMutationResult = Apollo.MutationResult<CompleteOrderMutation>;
export type CompleteOrderMutationOptions = Apollo.BaseMutationOptions<
  CompleteOrderMutation,
  CompleteOrderMutationVariables
>;
export const AcceptWorkDocument = gql`
    mutation AcceptWork($orderId: String!) {
  acceptWorkSubmission(orderId: $orderId) {
    id
  }
}
    `;
export type AcceptWorkMutationFn = Apollo.MutationFunction<
  AcceptWorkMutation,
  AcceptWorkMutationVariables
>;

/**
 * __useAcceptWorkMutation__
 *
 * To run a mutation, you first call `useAcceptWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptWorkMutation, { data, loading, error }] = useAcceptWorkMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAcceptWorkMutation(
  baseOptions?: Apollo.MutationHookOptions<AcceptWorkMutation, AcceptWorkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptWorkMutation, AcceptWorkMutationVariables>(
    AcceptWorkDocument,
    options,
  );
}
export type AcceptWorkMutationHookResult = ReturnType<typeof useAcceptWorkMutation>;
export type AcceptWorkMutationResult = Apollo.MutationResult<AcceptWorkMutation>;
export type AcceptWorkMutationOptions = Apollo.BaseMutationOptions<
  AcceptWorkMutation,
  AcceptWorkMutationVariables
>;
export const ResolveIssueDocument = gql`
    mutation ResolveIssue($actionId: String!, $issueId: String!) {
  resolveIssue(actionId: $actionId, issueId: $issueId) {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;
export type ResolveIssueMutationFn = Apollo.MutationFunction<
  ResolveIssueMutation,
  ResolveIssueMutationVariables
>;

/**
 * __useResolveIssueMutation__
 *
 * To run a mutation, you first call `useResolveIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveIssueMutation, { data, loading, error }] = useResolveIssueMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useResolveIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<ResolveIssueMutation, ResolveIssueMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResolveIssueMutation, ResolveIssueMutationVariables>(
    ResolveIssueDocument,
    options,
  );
}
export type ResolveIssueMutationHookResult = ReturnType<typeof useResolveIssueMutation>;
export type ResolveIssueMutationResult = Apollo.MutationResult<ResolveIssueMutation>;
export type ResolveIssueMutationOptions = Apollo.BaseMutationOptions<
  ResolveIssueMutation,
  ResolveIssueMutationVariables
>;
export const StoreDiscountDocument = gql`
    mutation StoreDiscount($code: String!) {
  storeDiscount(code: $code) {
    ...DiscountReceipt
  }
}
    ${DiscountReceiptFragmentDoc}`;
export type StoreDiscountMutationFn = Apollo.MutationFunction<
  StoreDiscountMutation,
  StoreDiscountMutationVariables
>;

/**
 * __useStoreDiscountMutation__
 *
 * To run a mutation, you first call `useStoreDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeDiscountMutation, { data, loading, error }] = useStoreDiscountMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStoreDiscountMutation(
  baseOptions?: Apollo.MutationHookOptions<StoreDiscountMutation, StoreDiscountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StoreDiscountMutation, StoreDiscountMutationVariables>(
    StoreDiscountDocument,
    options,
  );
}
export type StoreDiscountMutationHookResult = ReturnType<typeof useStoreDiscountMutation>;
export type StoreDiscountMutationResult = Apollo.MutationResult<StoreDiscountMutation>;
export type StoreDiscountMutationOptions = Apollo.BaseMutationOptions<
  StoreDiscountMutation,
  StoreDiscountMutationVariables
>;
